import type React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useModal } from 'app/shared/contexts/ModalContext/useModal';
import InstantTour from 'app/shared/modules/hdp/InstantTour';
import type { RootReduxState } from 'app/shared/flux/reducers/index';

interface InstantTourModalContentProps {
  onClose: () => void;
  isModifyingTour?: boolean;
}

/**
 * Content-only wrapper for the InstantTour (tour) modal.
 * Used by the ModalContext system, which provides its own modal shell, so
 * ?instantTour=true / ?webviewModal=InstantTour open the tour from a URL the same
 * way CostsAndFeesModalContent does for Costs & Fees. InstantTour derives its own
 * webview state from the URL query, and the shell hides the close button in webview.
 */
const InstantTourModalContent: React.FC<InstantTourModalContentProps> = ({ onClose, isModifyingTour = false }) => {
  const { openModal } = useModal();
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails.currentListing);
  const similarListings = useSelector((state: RootReduxState) => state.fetchListing.similarListings);

  // Post-booking "Contact property" CTA. Pass the listing/similarListings the
  // Contact modal requires (it reads listing directly), mirroring the HDP handlers.
  const openContactModal = useCallback(
    () => openModal({ type: 'contact', props: { listing, similarListings, isPopup: true } }),
    [openModal, listing, similarListings],
  );

  return <InstantTour isModifyingTour={isModifyingTour} onHidePopup={onClose} onActionPopup={openContactModal} />;
};

export default InstantTourModalContent;
